import { Location } from "@/interfaces/location";
import { LocationState } from "@/vuex/modules/locations/locations.types";
import { TablePagination } from "helix-vue-components";
import { MutationTree } from "vuex";

type LocationMutationTree = MutationTree<LocationState>;

export const mutations: LocationMutationTree = {
  setLocations(state: LocationState, locations: Location[]) {
    state.locations = locations;
  },
  setLoading(state: LocationState, loading: boolean) {
    state.loading = loading;
  },
  setCurrentLocation(state: LocationState, location: Location | null) {
    state.currentLocation = location;
  },
  setPagination(state: LocationState, pagination: TablePagination | null) {
    state.pagination = pagination;
  },
  setDisabledMode(state: LocationState, disable: boolean) {
    state.disabledMode = disable;
  }
};
